import { getTeamsBySeasonV2, getPlayersBySeason } from '@/utils/api/teams';
import { getPlayContentIndex } from '@/data/media-player-play-indexes';
import axios from 'axios';
const playIndexes = getPlayContentIndex();

export default {
  namespaced: true,
  state: {
    positions: [
      { name: 'Portero' },
      { name: 'Defensa central' },
      { name: 'Lateral por izquierda' },
      { name: 'Lateral por derecha' },
      { name: 'Volante por izquierda' },
      { name: 'Volante por derecha' },
      { name: 'Volante defensivo' },
      { name: 'Volante ofensivo' },
      { name: 'Delantero' },
      { name: 'Desconocida' },
    ],
    tournamentID: null,
    seasonID: null,
    teamID: null,
    playerID: null,
    teams: [],
    teamsMobile: [],
    players: [],
    playersByTeam: [],
    playersByTeamMobile: [],
    tournaments: [],
    player: null,
    retroSeason: null,
    retroTournament: {
      seasons: [],
    },
    lastSeason: null,
    isModalOpen: false,
    playlistIndex: 0,
    modalInitialState: {
      categoryId: [],
      mainSectionType: 1, // 1 = videoplayer, 2 = my playlists
      playListType: 1, // 1 = partidos, 2 = jugadores, 3 = equipos
      gameIds: [], // array de id de partido, en caso de no ser necesario dejar en cero 0
      playerIds: [], // ids de jugador, en caso de no ser necesario dejar array vacio
      teamId: 0, // id de equipo, en caso de no ser necesario dejar en cero 0
      matchResult: [], // array 1 = gana, 2 = pierde, 3 = empate, los 3 ids mostrar todo
      playData: {
        // objeto con la informacion de la jugada seleccionada o null
        /**
         * Objeto de la jugada seleccionada, en casos como chalkboard o porteria de goles,
         * puede tener mas o menos campos dependiendo el origen, por ejemplo las jugadas en el
         * componente {@see module:SoccerChalkboard.computed.preparedPlays}.
         * Los campos disponibles de cada tipo de jugada estan en:
         * {@see module:teamGoalPlayIndexes}
         * {@see module:teamStatsPlayIndexes}
         * {@see module:playerGoalPlayIndexes}
         * {@see module:playerStatsPlayIndexes}
         */
      },
      lastClashedGameId: null, // only for last clashes in bets
      tournamentsLastClashes: null, // only for last clashes in bets
      advancedFilter: {
        playListTitle: '',
        // valores para filtro avanzado, en caso de no ser cesario dejar en null
        mainCategoryId: {}, // array de categoria seleccionada
        // subCategoryIds: [], // ids de subcategorias activas
        playingAs: [1, 2], // array 1  local, 2 visitante, ambos todos
        timeSections: [1, 2, 3, 4, 5, 6], // 1 = 0-15, 2 = 16-30, 3 = 31-45, 4 = 46-60, 5 = 61-75, 6 = 76-90,
        fieldSections: [
          // secciones de la cancha seleccionadas
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
        ],
      },
      objectPlaySync: null, // sync play seconds between media players { numberPlayId, numberCurrentTime }
    },

    /*
     * when summary data has data is an object like below
     * subjectId can be player o team id
     *  { isTeam: Boolean, subjectId: number, teamId: number }
     */
    summaryData: null,
    userPlaylists: [],
    playsSaved: new Set(),
    playsToSaveAsFavorites: [],
    playersMapMyPlaylists: new Map(),
    teamsMapMyPlaylists: new Map(),
    gamesMapMyPlaylists: new Map(),
    maxGameIdMyPlaylists: 0,
    initialDataForLandingButton: {
      general: {
        seasonId: 0,
        playsType: 'goals',
        currentCategories: [],
        selectedType: 1,
        tournamentsForModalLauncher: new Map(),
        teamId: 0,
        playlistIndex: 0,
        player: null,
      },
      summary: {
        seasonId: 0,
        playsType: 'goals',
        currentCategories: [],
        selectedType: 1,
        tournamentsForModalLauncher: new Map(),
        teamId: 0,
        playlistIndex: 0,
        player: null,
      },
    },
    objectMediaData: null,
    mapMinutesPlayedCategoryNames: new Map(),
    playSeekerUserId: '',
    playSeekerCurrentSessionId: '',
  },
  getters: {
    userPlaylistsSeasonIds(state) {
      return state.userPlaylists.reduce((accumulator, playlist) => {
        playlist.plays.forEach(play => {
          const seasonId = play[playIndexes.seasonId];
          if (seasonId) {
            accumulator.add(seasonId);
          }
        });
        return accumulator;
      }, new Set());
    },
    playsSaved(state) {
      return state.userPlaylists.reduce((accumulator, playlist) => {
        playlist.plays.forEach(play => {
          accumulator.add(play[playIndexes.playId]);
        });
        return accumulator;
      }, new Set());
    },
    isPlayerGoalkeeper: state => {
      if (state.player) {
        return state.player.position_name === 'Portero' || state.player.positionId === 1;
      }
      return false;
    },
    getPlayers: state => {
      return state.playersByTeam;
    },
    getPlayersMobile: state => {
      return state.playersByTeamMobile;
    },
    getTeams: state => {
      return state.teams;
    },
    getTeamsMobile: state => {
      return state.teamsMobile;
    },
    getTeamId: state => {
      return state.teamID;
    },
    getTournamentId: state => {
      return state.tournamentID;
    },
    getSeasonId: state => {
      return state.seasonID;
    },
    getSeasonIdOnly: state => {
      return state.seasonID ? state.seasonID.id : null;
    },
    getPlayerId: state => {
      return state.playerID;
    },
    playersByTeam: state => {
      return state.players.reduce((accumulator, player) => {
        const playerAux = {
          id: player.player_id,
          name: player.player_name,
          shortName: player.shortName,
          photo: player.player_photo,
          teamId: player.team_id,
          positionId: player.position_id,
        };
        const teamPlayers = accumulator.get(player.team_id);
        if (teamPlayers) {
          teamPlayers.push(playerAux);
        } else {
          accumulator.set(player.team_id, [playerAux]);
        }
        return accumulator;
      }, new Map());
    },
    seasonPlayers: state => {
      return state.players.reduce((accumulator, player) => {
        accumulator.set(player.player_id, {
          id: player.player_id,
          name: player.player_name,
          shortName: player.shortName,
          photo: player.player_photo,
          teamId: player.team_id,
          positionId: player.position_id,
        });
        return accumulator;
      }, new Map());
    },
    selectedTournament: state => {
      return state.tournamentID ? state.tournaments.find(tournament => tournament._id === state.tournamentID.id) : null;
    },
  },
  mutations: {
    setPlaySeekerUserId(state, playSeekerUserId) {
      state.playSeekerUserId = playSeekerUserId;
    },
    setPlaySeekerCurrentSessionId(state, playSeekerCurrentSessionId) {
      state.playSeekerCurrentSessionId = playSeekerCurrentSessionId;
    },
    setMapMinutesPlayedCategoryNames(state, mapMinutesPlayedCategoryNames) {
      if (state.mapMinutesPlayedCategoryNames.size === 0) {
        state.mapMinutesPlayedCategoryNames = mapMinutesPlayedCategoryNames;
      }
    },
    setObjectMediaData(state, objectMediaData) {
      state.objectMediaData = objectMediaData;
    },
    setModalPlayer(state, { mediaPlayerType = 'general', player }) {
      state.initialDataForLandingButton[mediaPlayerType].player = player;
    },
    setSeasonId(state, { mediaPlayerType = 'general', seasonId }) {
      state.initialDataForLandingButton[mediaPlayerType].seasonId = seasonId;
    },
    setPlaysType(state, { mediaPlayerType = 'general', playsType }) {
      state.initialDataForLandingButton[mediaPlayerType].playsType = playsType;
    },
    setCurrentCategories(state, { mediaPlayerType = 'general', currentCategories }) {
      state.initialDataForLandingButton[mediaPlayerType].currentCategories = currentCategories;
    },
    setSelectedType(state, { mediaPlayerType = 'general', selectedType }) {
      state.initialDataForLandingButton[mediaPlayerType].selectedType = selectedType;
    },
    setTournamentsForModalLauncher(state, { mediaPlayerType = 'general', tournamentsForModalLauncher }) {
      state.initialDataForLandingButton[mediaPlayerType].tournamentsForModalLauncher = tournamentsForModalLauncher;
    },
    setTeamId(state, { mediaPlayerType = 'general', teamId }) {
      state.initialDataForLandingButton[mediaPlayerType].teamId = teamId;
    },
    setPlayersMapMyPlaylists(state, playersMapMyPlaylists) {
      state.playersMapMyPlaylists = playersMapMyPlaylists;
    },
    setTeamsMapMyPlaylists(state, teamsMapMyPlaylists) {
      state.teamsMapMyPlaylists = teamsMapMyPlaylists;
    },
    setGamesMapMyPlaylists(state, gamesMapMyPlaylists) {
      state.gamesMapMyPlaylists = gamesMapMyPlaylists;
    },
    setMaxGameIdMyPlaylists(state, maxGameIdMyPlaylists) {
      state.maxGameIdMyPlaylists = maxGameIdMyPlaylists;
    },
    setUserPlaylists(state, userPlaylists = []) {
      state.userPlaylists = userPlaylists;
    },
    setPlaysToSaveAsFavorites(state, playsToSaveAsFavorites = []) {
      state.playsToSaveAsFavorites = playsToSaveAsFavorites;
    },
    setPlaylistIndex(state, { mediaPlayerType, playlistIndex }) {
      state.playlistIndex = playlistIndex;
      if (mediaPlayerType) {
        state.initialDataForLandingButton[mediaPlayerType].playlistIndex = playlistIndex;
      }
    },
    setSummaryData(state, summaryData) {
      state.summaryData = summaryData;
    },
    setIsModalOpen(state, isModalOpen) {
      state.isModalOpen = isModalOpen;
    },
    setModalInitialState(state, modalInitialState) {
      state.modalInitialState = modalInitialState;
    },
    setLastSeason(state, lastSeason) {
      state.lastSeason = lastSeason;
    },
    setRetroTournament(state, retroTournament) {
      state.retroTournament = retroTournament;
    },
    setRetroSeason(state, retroSeason) {
      state.retroSeason = retroSeason;
    },
    setTournaments(state, tournaments) {
      tournaments.forEach(tournament => {
        tournament.seasons.forEach((season, index) => {
          season.index = index;
        });
      });
      state.tournaments = tournaments;
    },
    setPlayersByTeam(state, id) {
      state.playersByTeam = id;
    },
    resetPlayer(state) {
      state.playerID = null;
    },
    setPlayersByTeamMobile(state, id) {
      state.playersByTeamMobile = id;
    },
    setPlayers(state, players) {
      state.players = players;
    },
    setTournament(state, id) {
      state.tournamentID = id;
    },
    setSeason(state, id) {
      state.seasonID = id;
    },
    setTeam(state, id) {
      state.teamID = id;
    },
    setPlayer(state, player) {
      state.player = player;
      state.playerID = player ? player.player_id || player.id : null;
    },
    setPlayerId(state, playerId) {
      state.playerID = playerId;
    },
    setTeams(state, teams) {
      state.teams = teams;
    },
    setTeamsMobile(state, teams) {
      state.teamsMobile = teams;
    },
  },
  actions: {
    async fetchTournaments({ commit }) {
      try {
        const { data } = await axios.get('https://i90k4l74ik.execute-api.us-east-2.amazonaws.com/prod/tournaments');
        commit('setTournaments', data);
      } catch (e) {
        throw new Error(e);
      }
    },
    async getPlayersByTeam({ commit, state }) {
      let position = 0;
      let playersArray = {};
      let playersMobileArray = {};
      const playersByTeam = state.players.filter(player => player.team_id === state.teamID);
      if (playersByTeam.length > 0) {
        for (let index = 0; index < playersByTeam.length; index++) {
          let indexInit = index;
          playersArray[indexInit] = [];
          let key =
            index + 1 > 6
              ? index + 1 > 12
                ? index + 1 > 18
                  ? index + 1 > 24
                    ? index + 1 > 30
                      ? index + 1 > 36
                        ? index + 1 > 42
                          ? index + 1 > 42
                          : index + 1 - 36
                        : index + 1 - 30
                      : index + 1 - 24
                    : index + 1 - 18
                  : index + 1 - 12
                : index + 1 - 6
              : index + 1;
          playersByTeam[indexInit].position_name = state.positions[playersByTeam[indexInit].position_id - 1].name;
          playersArray[indexInit]['index'] = key;
          let dataNamePlayer = playersByTeam[indexInit].player_name.split(',');
          playersArray[indexInit]['data'] = playersByTeam[indexInit];
          playersArray[indexInit]['name'] = dataNamePlayer[0];
          playersArray[indexInit]['surname'] = dataNamePlayer[1];

          let ageDifMs = Date.now() - new Date(playersByTeam[indexInit].dob);
          let ageDate = new Date(ageDifMs); // miliseconds from epoch

          playersByTeam[indexInit].dob = Math.abs(ageDate.getUTCFullYear() - 1970);

          if (key === 1) {
            position++;
            playersMobileArray[position] = [];
            playersMobileArray[position].push(playersArray[indexInit]);
          } else {
            playersMobileArray[position].push(playersArray[indexInit]);
          }
        }
        commit('setPlayersByTeamMobile', playersMobileArray);
        commit('setPlayersByTeam', playersArray);
      }
    },

    async getPlayersBySeasons({ commit, getters }, payload) {
      try {
        const response = await getPlayersBySeason({
          seasonId: payload && payload.seasonId ? payload.seasonId : getters.selectedTournament.seasons[0].id,
        });
        response.data.players.forEach(player => {
          const [lastName, name] = player.player_name.split(',');
          const lastNameArr = lastName.split(' ');
          let lastNameShort = '';
          for (const word of lastNameArr) {
            lastNameShort += ` ${word}`;
            if (word.length > 3) {
              break;
            }
          }
          player.shortName = name && lastName ? `${name.trim().charAt(0)}.${lastNameShort}` : '';
        });
        if (payload.returnData) {
          return response.data.players;
        } else {
          commit('setPlayers', response.data.players);
        }
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async getTeamsBySeasons({ commit, state }, payload = { seasonId: 0 }) {
      try {
        var position = 0;
        var teamsArray = {};
        var teamsMobileArray = {};
        const teams = await getTeamsBySeasonV2({
          seasonId: payload.seasonId || state.seasonID.id,
        });
        if (teams.data.teams) {
          for (let index = 0; index < teams.data.teams.length; index++) {
            var indexInit = index;
            teamsArray[indexInit] = [];
            var key =
              index + 1 > 6
                ? index + 1 > 12
                  ? index + 1 > 18
                    ? index + 1 > 24
                      ? index + 1 > 30
                        ? index + 1 > 36
                          ? index + 1 > 42
                            ? index + 1 > 42
                            : index + 1 - 36
                          : index + 1 - 30
                        : index + 1 - 24
                      : index + 1 - 18
                    : index + 1 - 12
                  : index + 1 - 6
                : index + 1;

            teamsArray[indexInit]['index'] = key;
            teamsArray[indexInit]['data'] = teams.data.teams[indexInit];
            if (key == 1) {
              position++;
              teamsMobileArray[position] = [];
              teamsMobileArray[position].push(teamsArray[indexInit]);
            } else {
              teamsMobileArray[position].push(teamsArray[indexInit]);
            }
          }
          commit('setTeams', teamsArray);
          commit('setTeamsMobile', teamsMobileArray);
        }
      } catch (e) {
        return Promise.reject(e);
      }
    },
    /**
     * @author Alejandro Martinez
     * @param {Object} payload
     * @param {Array<number>} payload.seasons - seasons ids
     * @return {Promise<{seasonsAndGames: *, seasonsAndTeams: *}|*|undefined>}
     */
    async fetchSeasonsGamesAndTeams(_, payload) {
      try {
        let gamesUrl = 'https://qyyibs1w0d.execute-api.us-west-2.amazonaws.com/prod/calendar/gamesBySeason?';
        // let gamesUrl = 'https://kkd48smit2.execute-api.us-west-2.amazonaws.com/qa/calendar/gamesBySeason?';
        payload.seasons.forEach((seasonId, index) => {
          const prefix = index === 0 ? '' : '&';
          gamesUrl += `${prefix}seasons=${seasonId}`;
        });
        const {
          data: { data, teams },
        } = await axios.get(gamesUrl);
        return { seasonsAndGames: data, seasonsAndTeams: teams };
      } catch (e) {
        throw new Error(e);
      }
    },
  },
};
